export {
  PendingApprovalModalComponent
} from './lib/pending-approval-modal/pending-approval-modal.component';
export {
  PendingApprovalModalService
} from './lib/pending-approval-modal/pending-approval-modal.service';
